import { api } from '../services/api';

export const useAdminBasesActions = (refreshData: () => void) => {
  const handleSave = async (
    id: number,
    updatedTitle: string,
    updatedDescription: string,
  ) => {
    const queryParams = new URLSearchParams({
      title: updatedTitle,
      description: updatedDescription,
      sale: 'true',
    });
    await api.patch(`/telegram/sales/db/${id}?${queryParams.toString()}`);

    refreshData();
  };

  const handleDelete = async (id: number) => {
    await api.delete(`/telegram/sales/db/${id}`);
    refreshData();
  };

  return { handleSave, handleDelete };
};
